export default {
  title: 'Télécharger SOSAFE',
  description:
    'Prenons soin les uns des autres. Plus nous serons nombreux, plus nous serons en sécurité!',
  googlePlayButton: 'Télécharger sur Google Play',
  appGalleryButton: 'Télécharger sur AppGallery',
};
